import CaseTestingConclusion from './CaseTestingConclusion'

export default CaseTestingConclusion
